import FollowCustomList from '@/pages/customManage/followCustomList'
import CusFollowDetail from '@/pages/customManage/followCustomList/cusFollowDetail/FollowDetail'
export default [
  {
    path: '/followCustomList',
    name: 'FollowCustomList',
    component: FollowCustomList,
    meta: { name: '客户列表' }
  },
  {
    path: '/followCustomList/cusFollowDetail/FollowDetail/:orderId',
    name: 'CusFollowDetail',
    component: CusFollowDetail,
    props: true,
    meta: { name: ['客户列表', '客户详情'] }
  }
]



// WEBPACK FOOTER //
// ./src/router/customManage/followCustomList.js